export const SEPARATOR = '^^^';
export const NEGATIVE_FILTER_TOKEN = '!HAKIMO_NEGATIVE!';
